// This file configures the initialization of Sentry for the Vite app.
// The config you add here will be used whenever the client loads a page.
// https://docs.sentry.io/platforms/javascript/guides/vite/

import * as Sentry from "@sentry/browser";
import { env } from "@/env";

// Only initialize Sentry in production and preview environments
const shouldInitializeSentry =
  env.VITE_APP_ENV === "production" || env.VITE_APP_ENV === "preview";

if (shouldInitializeSentry) {
  Sentry.init({
    dsn: "https://9247ffbb9de53db731a7e8f66727d81d@o4509629395304448.ingest.de.sentry.io/4510036619165776",

    // Add optional integrations for additional features
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,

    // Set the environment based on APP_ENV
    environment: env.VITE_APP_ENV,

    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // Define how likely Replay events are sampled when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    sendDefaultPii: true,
  });
}
